import { Box } from "@mui/material";

const SystemDetection = () => {
  return (
    <Box m={"20px"}>

    </Box>
  )
};

export default SystemDetection;